import gql from 'graphql-tag';

export default gql`
  mutation ResolveManualAction($vpId: ID!) {
    resolveManualAction(vpId: $vpId) {
      vpId
      status
      message
      updatedAt
    }
  }
`;
